var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * "How vocabularies are created" operator help content (CZNA-366, epic
 * CZNA-297d), rendered inside a `<PaneHelpButton>` popover on the
 * derivation rules list screen (originally a collapsed in-body Accordion,
 * moved to a pane-header "?" popover per CZNA-366 Kontrola feedback —
 * the accordion was easy to miss and not recognizable as help).
 *
 * A concise, cataloguer-facing reference, backed entirely by i18n keys
 * under `derivationRules.overviewHelp.*`.
 *
 * Complements the per-field `<HelpTooltip>`/`<FormHelp>` kit (CZNA-380) used
 * inside `DerivationRuleDetail`: those explain individual fields on the rule
 * being edited, while this content explains the derivation *subsystem* as a
 * whole — the 3 threshold strategies, the auto-on-import mechanism, the
 * manual "derive" dry-run/confirm flow, why a back-derivation run is needed
 * after adding/changing a rule, and what the run-history audit log shows.
 *
 * Longer-form prose (with worked examples and full column-by-column detail)
 * lives in `VocabularyDerivationReferenceDoc.md` alongside the backend
 * derivation service — this is the in-app quick reference.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { Headline } from '@folio/stripes/components';
var codeStyle = {
    fontFamily: 'monospace',
    fontSize: '0.85em',
    whiteSpace: 'pre-wrap',
};
var sectionStyle = { marginBottom: '0.75rem' };
var headingStyle = { fontWeight: 600, marginBottom: '0.25rem' };
var listStyle = { margin: 0, paddingLeft: '1.25rem' };
var DerivationHelpContent = function () {
    var intl = useIntl();
    var t = function (id) { return intl.formatMessage({ id: "ui-czna-authorities.derivationRules.overviewHelp.".concat(id) }); };
    return (React.createElement("div", { "data-testid": "derivation-help-content", style: { fontSize: '0.9em' } },
        React.createElement(Headline, { size: "medium", margin: "none" }, t('title')),
        React.createElement("div", { style: __assign(__assign({}, sectionStyle), { marginTop: '0.75rem' }) },
            React.createElement("div", { style: headingStyle }, t('thresholdStrategies.heading')),
            React.createElement("ul", { style: listStyle },
                React.createElement("li", null,
                    React.createElement("span", { style: codeStyle }, "FREQUENCY"),
                    ' — ',
                    t('thresholdStrategies.frequency')),
                React.createElement("li", null,
                    React.createElement("span", { style: codeStyle }, "COVERAGE_PERCENTILE"),
                    ' — ',
                    t('thresholdStrategies.coveragePercentile')),
                React.createElement("li", null,
                    React.createElement("span", { style: codeStyle }, "EXPLICIT_LIST"),
                    ' — ',
                    t('thresholdStrategies.explicitList')))),
        React.createElement("div", { style: sectionStyle },
            React.createElement("div", { style: headingStyle }, t('autoOnImport.heading')),
            React.createElement("div", null, t('autoOnImport.text'))),
        React.createElement("div", { style: sectionStyle },
            React.createElement("div", { style: headingStyle }, t('manualDerive.heading')),
            React.createElement("div", null, t('manualDerive.text'))),
        React.createElement("div", { style: sectionStyle },
            React.createElement("div", { style: headingStyle }, t('backDerivation.heading')),
            React.createElement("div", null, t('backDerivation.text'))),
        React.createElement("div", { style: sectionStyle },
            React.createElement("div", { style: headingStyle }, t('auditLog.heading')),
            React.createElement("div", null, t('auditLog.text')))));
};
export default DerivationHelpContent;
